import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> tk

  <span style="color:#85c1dc;">**FI:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> kpl

  <span style="color:#85c1dc;">**RU:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> шт
*/
/* @__NO_SIDE_EFFECTS__ */
const m1896 = msg(
  mf`${'quantity'} tk`,
  mf`${'quantity'} kpl`,
  mf`${'quantity'} шт`,
)

export { m1896 as 'w.global.product_quantity_text' }